import { functionsService } from "../services/functionsService";
import {
  PRIVACY_CONSENT_VERSION,
  PRIVACY_ANALYTICS_SESSION_STORAGE_KEY,
  readPrivacyConsent,
} from "../privacy/consentStorage";

export type ConversionEventName =
  | "page_view"
  | "organizer_cta_click"
  | "organizer_pricing_view"
  | "organizer_lead_submitted"
  | "public_race_view"
  | "public_race_register_click"
  | "public_race_share"
  | "registration_completed"
  | "race_submitted";

type ConversionEventDetails = {
  pagePath?: string;
  raceId?: string;
  cta?: string;
};

const createSessionId = (): string => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${Math.random()
    .toString(36)
    .slice(2)}`;
};

const getSessionId = (): string => {
  try {
    const existing = window.sessionStorage.getItem(PRIVACY_ANALYTICS_SESSION_STORAGE_KEY);
    if (existing) return existing;
    const next = createSessionId();
    window.sessionStorage.setItem(PRIVACY_ANALYTICS_SESSION_STORAGE_KEY, next);
    return next;
  } catch {
    return createSessionId();
  }
};

const getReferrerHost = (): string => {
  if (!document.referrer) return "";
  try {
    const referrer = new URL(document.referrer);
    return referrer.hostname === window.location.hostname ? "" : referrer.hostname;
  } catch {
    return "";
  }
};

export const trackConversion = (
  eventName: ConversionEventName,
  details: ConversionEventDetails = {}
): void => {
  if (typeof window === "undefined") return;
  const preferences = readPrivacyConsent();
  if (preferences?.analytics !== true) return;

  const params = new URLSearchParams(window.location.search);
  void functionsService
    .trackConversionEvent({
      eventName,
      pagePath: details.pagePath || window.location.pathname,
      sessionId: getSessionId(),
      raceId: details.raceId,
      cta: details.cta,
      source: params.get("utm_source") || undefined,
      medium: params.get("utm_medium") || undefined,
      campaign: params.get("utm_campaign") || undefined,
      referrerHost: getReferrerHost() || undefined,
      analyticsConsent: true,
      consentVersion: PRIVACY_CONSENT_VERSION,
    })
    .catch(() => {
      // Measurement must never interrupt the requested product action.
    });
};

export const analyticsSessionStorageKey = PRIVACY_ANALYTICS_SESSION_STORAGE_KEY;
